import * as storage from './storage';

export async function getAppConfig(isSaveConfig = false) {
    const response = await fetch(`${process.env.PUBLIC_URL}/client_appconfig.json`);
    const settings = await response.json();

    if (isSaveConfig) {
        await saveConfig(settings);
    }

    return settings;
}

function saveConfig(config) {
    return new Promise(async (resolve) => {
        await storage.init();
        storage.saveConfigShowError(config.ShowError);
        storage.saveConfigValidateMinutesInterval(config.Token.ValidateMinutesInterval);
        storage.saveConfigRenewMinutes(config.Token.RenewMinutes);
        storage.saveConfigLogInfoDevice(config.LogInfoDevice);
        storage.saveConfigRootBase(config.EntraId.RootBase);
        storage.saveConfigClientId(config.EntraId.ClientId);
        storage.saveConfigTenantId(config.EntraId.TenantId);
        storage.saveConfigAuthority(config.EntraId.Authority);
        storage.saveConfigRedirectUri(config.EntraId.RedirectUri);
        storage.saveConfigRedirectLogout(config.EntraId.RedirectLogout);
        storage.saveConfigIntervalWaitSSO(config.IntervalWaitSSO);

        if (config.OnlineHelp) {
            storage.saveConfigOnlineHelpFrenchLink(config.OnlineHelp.FrenchLink);
            storage.saveConfigOnlineHelpEnglishLink(config.OnlineHelp.EnglishLink);
        } else {
            storage.saveConfigOnlineHelpFrenchLink('https://aideenligne.algodesign.com/mobile/mobile.htm');
            storage.saveConfigOnlineHelpEnglishLink('https://onlinehelp.algodesign.com/mobile/mobile.htm');
        }

        if (config.CompanyTitle) {
            storage.saveConfigCompanyTitle(config.CompanyTitle);
        } else {
            storage.saveConfigCompanyTitle('');
        }

        resolve();
    })
}